import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  margin: 0 0 1rem;
  h2 {
    margin: 0 0 1.5rem;
    color: ${({ theme }) => theme.textColor.default};
  }
  p {
    display: flex;
    align-items: center;
    margin: 0 0 2rem;
    small {
      font-size: ${({ theme }) => theme.font.size.text.small};
    }
  }
`

const SidebarIntro = ({ children }) => (
  <Wrapper>
    {children}
  </Wrapper>
)

export default SidebarIntro;